import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BannerComponent } from '../../../../shared/components/banner/banner.component';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { BannerType } from 'src/app/shared/components/banner/banner.model';
import { RemoteConfigStore } from '@store';

@Component({
  selector: 'app-generic-info-banner',
  standalone: true,
  imports: [CommonStandaloneModule, BannerComponent],
  templateUrl: './generic-info-banner.component.html',
  styleUrls: ['./generic-info-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericInfoBannerComponent {
  readonly BannerType = BannerType;

  constructor(public remoteConfigStore: RemoteConfigStore) {}
}
